import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {WindowRef} from '../../../../../app/services/window-ref.service';
import {TranslateService} from '@ngx-translate/core';
import {ApiGraphboardsService} from '../../../services/api-graphboards.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {EnvService} from '../../../../../app/services/env.service';

@Component({
    selector: 'app-graphboards-pdf-modal',
    templateUrl: './graphboards-pdf-modal.component.html',
    styleUrls: ['./graphboards-pdf-modal.component.scss']
})
export class GraphboardsPdfModalComponent implements OnInit, OnDestroy {

    @Input() config;
    @Input() itemToDisplay;
    public close: EventEmitter<any> = new EventEmitter();

    pdfStructure: any;
    pdfEmail: any;
    pdfToken: string;
    pdfReportUrl: string;
    nativeWindow: any;

    mailto: string;
    serverText: string;

    selectMethod = false;

    method = 'pdf';
    share = 'none';

    private subscriptions = new Subscription();

    constructor(
        public bsModalRef: BsModalRef,
        private apiGraphboardsService: ApiGraphboardsService,
        private changeDetectorRef: ChangeDetectorRef,
        private windowRef: WindowRef,
        public translate: TranslateService,
        private environment: EnvService
    ) {
        this.nativeWindow = windowRef.getNativeWindow();
    }

    ngOnInit() {
        this.initPdfStructure();
    }

    initPdfStructure() {
        // PDF structure
        this.pdfStructure = Object.assign({}, {
            designDePoste: 0,
            graphiques: 0
        });

        // PDF email
        this.pdfEmail = Object.assign({}, {
            emailTo: '',
            subject: (this.translate.currentLang === 'fr') ? 'Rapport Multigraphe' : 'Graphboard Report',
            message: '',
        });

        // PDF link
        this.pdfToken = null;
        this.pdfReportUrl = this.environment.pdfReportUrl;
    }

    getReportData(data: any) {

        let obs = this.apiGraphboardsService.reportGraphboard([this.itemToDisplay.id], [
            [
                3
            ],
            this.translate.currentLang
        ]);

        this.subscriptions.add(obs.subscribe(
            res => {
                this.pdfToken = encodeURI(res.pdfToken);

                this.pdfReportUrl = this.environment.pdfReportUrl + '?tokenDefinition=' + this.pdfToken;
                if (this.translate.currentLang === 'fr') {
                    if ('mailto' === data.type) {
                        this.mailto = '?subject=Rapport pour l\'analyse Graphboard ' + this.itemToDisplay.name + '&body=Vous pouvez voir le rapport pour' +
                            ' l\'analyse Graphboard ' + this.itemToDisplay.name + ' en cliquant sur le lien suivant :%0A%0A ' + this.pdfReportUrl;
                    } else if ('share' === data.type) {
                        this.serverText = `Vous pouvez voir le rapport pour l'analyse Graphboard ` +
                            this.itemToDisplay.name +
                            ` en cliquant sur le lien suivant :

                        ` + this.pdfReportUrl + encodeURI(this.pdfToken);
                    }
                } else if (this.translate.currentLang === 'en') {
                    if ('mailto' === data.type) {
                        this.mailto = '?subject=' + this.itemToDisplay.name + ' Graphboard Analysis Report&body=You can see the report for' +
                            ' the Graphboard Analysis ' + this.itemToDisplay.name + ' by clicking here:%0A%0A ' + this.pdfReportUrl;
                    } else if ('share' === data.type) {
                        this.serverText = `You can see the report for the Graphboard Analysis ` +
                            this.itemToDisplay.name +
                            ` by clicking here:

                        ` + this.pdfReportUrl + encodeURI(this.pdfToken);
                    }
                }


                if (data.window && 'download' === data.type) {
                    data.window.document.location.href = this.pdfReportUrl;
                    this.closeModal();
                    return;
                }

                this.changeDetectorRef.markForCheck();
            }
        ));
    }

    downloadReport() {
        // Open window to avoid popup blocking
        let pdfWindow = this.nativeWindow.open('', '_blank');
        this.getReportData({type: 'download', window: pdfWindow});
    }

    sendEmailReport() {
        if (!this.pdfEmail || this.pdfEmail.subject === '') {
            this.pdfEmail.subject = (this.translate.currentLang === 'fr') ? 'Rapport Multigraphe' : 'Graphboard Report';
        }
        const dataEmail = [
            this.pdfEmail.emailTo,
            this.pdfEmail.subject,
            this.pdfEmail.message,
            this.pdfReportUrl,
            this.itemToDisplay.name,
            'graphboards',
            this.translate.currentLang
        ];

        this.subscriptions.add(this.apiGraphboardsService.reportEmail(dataEmail).subscribe());

        this.closeModal();
    }

    handleReport() {
        switch (this.method) {
            case 'pdf':
                this.downloadReport();
                return;
            case 'cutpaste':
                this.share = 'cutpaste';
                this.getReportData({type: 'token'});
                return;
            case 'mailto':
                this.share = 'mailto';
                this.getReportData({type: 'mailto'});
                return;
            case 'server':
                this.share = 'server';
                this.getReportData({type: 'share'});
                return;
        }
        this.selectMethod = true;
        return;

    }

    changeSelectMethodState() {
        if (this.method !== 'none') {
            this.selectMethod = false;
        }
    }

    cancel() {
        this.share = 'none';
        this.method = 'pdf';
    }

    delay(time) {
        return new Promise(resolve => setTimeout(resolve, time));
    }

    closeModal() {
        this.delay(1000).then(() => {
            this.cancel();
            this.initPdfStructure();
        });
        this.close.emit({closed: true});
        this.bsModalRef.hide();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.close.emit({closed: true});
    }

}
